import { ChevronRight } from 'lucide-react';
import { Map, Store, TrendingUp, CircleDollarSign, Headphones } from '../../components/CustomIcons';

export default function Struggling() {
  const steps = [
    {
      icon: <Map className="w-6 h-6 text-orange-500" />,
      title: "Don't know where to start?",
      desc: "We guide you step-by-step"
    },
    {
      icon: <Store className="w-6 h-6 text-orange-500" />,
      title: "Confused about selling platforms?",
      desc: "We help you choose the right one"
    },
    {
      icon: <TrendingUp className="w-6 h-6 text-orange-500" />,
      title: "Not getting sales?",
      desc: "We teach proven strategies that work"
    },
    {
      icon: <CircleDollarSign className="w-6 h-6 text-orange-500" />,
      title: "Wasting money on ads?",
      desc: "Learn how to run profitable PPC campaigns"
    },
    {
      icon: <Headphones className="w-6 h-6 text-orange-500" />,
      title: "Need expert support?",
      desc: "Get lifetime mentorship and doubt support"
    }
  ];

  return (
    <section className="py-16 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
            Struggling To Start Your <span className="text-orange-500">E-Commerce Business?</span>
          </h2>
          <p className="text-gray-600 font-medium">
            We Have The Right Path For You!
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center max-w-[200px] relative">
              <div className="w-16 h-16 rounded-2xl bg-orange-50 flex items-center justify-center mb-6 shadow-sm border border-orange-100/50">
                {step.icon}
              </div>
              <h4 className="text-sm font-bold text-gray-900 mb-2 leading-snug">
                {step.title}
              </h4>
              <p className="text-xs text-gray-500 leading-relaxed">
                {step.desc}
              </p>
              
              {/* Arrow connector for large screens */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute -right-6 top-8 text-gray-200">
                  <ChevronRight className="w-5 h-5" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
